// Nhan vien ban hang
export const NAV_CODE_NHAN_VIEN_BAN_HANG = `20221013084213360`;

// Menu hoach dinh tai chinh ca nhan
export const NAV_CODE_HOACH_DINH_TAI_CHINH_CA_NHAN = `20221026135941346`;

// Quản lý đầu tư Home
export const NAV_CODE_QUAN_LY_DAU_TU_HOME = `20220915145257442`;
